// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__37BNl","footer":"ReportModalFilter_footer__1Zv63"};